import React from "react";

const TextArea = ({ label, placeholder, ...props }) => {
  return (
    <div className="flex flex-col space-y-4">
      <label className="text-sm font-semibold text-[#0F172A]">{label}</label>
      <textarea
        placeholder={placeholder}
        className="w-full border py-3 px-3 rounded-xl h-[100px]	border-[#E2E8F0] resize-none"
        {...props}
      />
    </div>
  );
};

export default TextArea;
